import React from "react";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../styles/HeroSerene-2.css";
import ContactPopup from "../components/ContactPopup";
import heroSlide1 from "../assets/serene-images/GATE-ELONGATED.avif";
import heroSlide2 from "../assets/serene-images/serene-clubhouse-banner.avif";
import heroSlide3 from "../assets/serene-images/aerial-view-serene.avif";
import heroSlide4 from "../assets/serene-images/STREET-DRIVE.avif";

const heroSlides = [heroSlide1, heroSlide2, heroSlide3];

const SereneHero = () => {

    const [openPopup, setOpenPopup] = useState(false);
    const [activeSlide, setActiveSlide] = useState(0);

    const heroTextLine1 = "VESSELLA";
    const heroTextLine2 = "SERENE";

    useEffect(() => {
        const intervalId = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % heroSlides.length);
        }, 6500);

        return () => clearInterval(intervalId);
    }, []);


    const letterContainer = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.04, // letter-by-letter
                delayChildren: 0.2,
            },
        },
    };

    const letterVariant = {
        hidden: {
            y: 120,              // bottom → top (important for hero)
            opacity: 0,
            filter: "blur(10px)",
        },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: {
                duration: 0.9,
                ease: [0.22, 1, 0.36, 1], // cinematic easing
            },
        },
    };






    return (
        <section className="serene-hero">
            {/* Background Image */}
            <motion.div
                className="serene-hero__bg"
                style={{ backgroundImage: `url(${heroSlides[0]})` }}
                initial={{ scale: 1.1, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 1.8, ease: "easeOut" }}
            >
                {heroSlides.map((slide, index) => (
                    <img
                        key={slide}
                        src={slide}
                        alt=""
                        aria-hidden="true"
                        className={`serene-hero__slide ${index === activeSlide ? "is-active" : ""}`}
                    />
                ))}
            </motion.div>

            {/* Overlay */}
            <motion.div
                className="serene-hero__overlay"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.2, delay: 0.3 }}
            />

            {/* Content */}
            <div className="serene-hero__content container">
                <div className="row">
                    <div className="col-md-6 col-12 p-lg-0">

                        <motion.p
                            className="serene-hero__rera mb-1 fw-bold"
                            initial={{ y: 30, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.4 }}>
                            RERA NUMBER : P02500009802
                        </motion.p>

                        {/* Subtitle */}
                        <motion.p
                            className="serene-hero__subtitle"
                            initial={{ y: 30, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.6 }}
                        >
                            Peace and charm without being far from vibrant life.
                        </motion.p>

                        {/* Title */}
                        <motion.h1
                            className="serene-hero__title"
                            variants={letterContainer}
                            initial="hidden"
                            animate="show"
                        >
                            {/* LINE 1 */}
                            <div className="hero-line">
                                {heroTextLine1.split("").map((char, i) => (
                                    <span key={`l1-${i}`} className="letter-mask">
                                        <motion.span
                                            variants={letterVariant}
                                            className="hero-letter"
                                        >
                                            {char === " " ? "\u00A0" : char}
                                        </motion.span>
                                    </span>
                                ))}
                            </div>

                            {/* LINE 2 */}
                            <div className="hero-line hero-line-big">
                                {heroTextLine2.split("").map((char, i) => (
                                    <span key={`l2-${i}`} className="letter-mask">
                                        <motion.span
                                            variants={letterVariant}
                                            className="hero-letter"
                                        >
                                            {char === " " ? "\u00A0" : char}
                                        </motion.span>
                                    </span>
                                ))}
                            </div>
                        </motion.h1>







                    </div>

                    {/* CTA */}
                    <div className="col-md-6 col-12 p-lg-0 d-flex align-items-end justify-content-end">
                        <motion.button
                            onClick={() => setOpenPopup(true)}
                            className="serene-hero__cta mb-5"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.7, delay: 1.2 }}
                            whileHover={{ x: 6 }}
                        >
                            Submit a request
                            <i className="fa-solid fa-arrow-right cta-arrow"></i>
                        </motion.button>

                        <ContactPopup
                            open={openPopup}
                            onClose={() => setOpenPopup(false)}
                            formType="serene"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SereneHero;
